import { render } from "./svg-icon.vue?vue&type=template&id=11a2f51e&scoped=true&bindings={\"type\":\"props\",\"path\":\"props\",\"size\":\"props\",\"viewbox\":\"props\",\"flip\":\"props\",\"rotate\":\"props\",\"styles\":\"options\",\"defaults\":\"options\",\"sizeValue\":\"options\",\"viewboxValue\":\"options\"}"
import script from "./svg-icon.vue?vue&type=script&lang=js"
export * from "./svg-icon.vue?vue&type=script&lang=js"

import "./svg-icon.vue?vue&type=style&index=0&id=11a2f51e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11a2f51e"

export default script